import React from "react";
import { ArrowRight, Users, UserPlus } from "lucide-react";
import { JOTFORM_URL } from "../constants";
import { useSite } from "../contexts/SiteContext";
import { resolveAssetUrl } from "../lib/api";

const Benefits = () => {
  const { content } = useSite();
  const b = content.benefits || {};
  const ref = b.referral || {};
  const grp = b.group || {};
  return (
    <section id="beneficios" style={{ padding: "30px 24px 90px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <div className="fade-in" style={{ maxWidth: 780, marginBottom: 40 }}>
          <span className="pill pill-orange" style={{ marginBottom: 16 }}>{b.kicker}</span>
          <h2 className="h-display" style={{ fontSize: "clamp(32px, 4.4vw, 56px)", margin: "12px 0 16px" }}>
            {b.titleLine1}<br />
            {b.titleLine2Prefix}<span className="text-grad-purple">{b.titleLine2Highlight}</span>{b.titleLine2Suffix}
          </h2>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 26, marginBottom: 32 }} className="benefits-grid">
          <article className="card-soft fade-in" style={{ padding: 0, display: "flex", overflow: "hidden" }}>
            <div className="img-zoom-wrap" style={{ width: "40%", flexShrink: 0 }}>
              <img src={resolveAssetUrl(ref.image)} alt="" className="img-zoom" />
            </div>
            <div style={{ padding: 28, display: "flex", flexDirection: "column", gap: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <UserPlus size={14} color="#FF4F1A" />
                <span style={{ color: "#FF4F1A", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>{ref.kicker}</span>
              </div>
              <h3 className="h-display" style={{ fontSize: 22, margin: 0 }}>{ref.title}</h3>
              <p style={{ color: "#5F5A72", fontSize: 13.5, lineHeight: 1.55, margin: 0 }}>{ref.desc}</p>
            </div>
          </article>

          <article className="fade-in" style={{ background: "linear-gradient(160deg,#5446EA,#3F2DCB)", color: "#fff", borderRadius: 28, padding: 32, display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Users size={14} color="#FFD8C6" />
              <span style={{ color: "#FFD8C6", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>{grp.kicker}</span>
            </div>
            <h3 className="h-display" style={{ fontSize: 26, color: "#fff", margin: 0 }}>{grp.title}</h3>
            <p style={{ color: "rgba(255,255,255,0.85)", fontSize: 14, lineHeight: 1.55, margin: "0 0 6px" }}>{grp.desc}</p>
            <a href={JOTFORM_URL} target="_blank" rel="noopener noreferrer" className="btn-orange" style={{ alignSelf: "flex-start", marginTop: 6 }}>
              {grp.ctaText} <ArrowRight size={15} />
            </a>
          </article>
        </div>
      </div>
      <style>{`@media (max-width: 900px){.benefits-grid{grid-template-columns:1fr !important;}.benefits-grid > article:first-child{flex-direction:column !important;}.benefits-grid > article:first-child > div:first-child{width:100% !important;aspect-ratio:16/9;}}`}</style>
    </section>
  );
};

export default Benefits;
